export const UXCamConfig = {
    userAppKey: process.env.REACT_APP_UX_CAM_KEY,
    enableAutomaticScreenNameTagging: false,
    enableImprovedScreenCapture: true,
};
